<template>
  <!-- <HubspotPermissionUpdateModal /> -->
  <div class="section">
    <div>
      Visualiza y descarga datos de la gestión de tu empresa.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </div>
    <a-row justify="space-between" align="middle" class="section__top">
      <a-space :size="12">
        <range-picker class="section__filter-range" @change="handleChange" :allowClear="false" />
        <entity-picker
          class="section__filter"
          :value="entity"
          @update:value="changeEntity($event)"
          withOutEntities
        />
        <campaign-picker
          class="section__filter"
          :value="portfolio"
          @update:value="changePortfolio($event)"
          :entity="entity"
          @onSetPortfolios="setPortfolios"
        />
        <QueuePicker
          class="section__filter"
          default-behavior
          with-out-portfolio
          :portfolio="portfolio === 0 ? [] : (portfolio || dataPortfolios)"
          v-model:value="queue"
          :disabled="portfolio === 0"
          @update:value="handleChangeQueue"
        />
      </a-space>
      <a class="section__button" @click="handleRefresh">Actualizar datos recientes</a>
    </a-row>
  </div>
  <custom-scrollbar :height="showBanner ? 'calc(100vh - 170px - 35px)' : 'calc(100vh - 170px)'">
    <div class="section" aria-label="dashboard-section">
      <dashboard-interaction-voice
        :key="dashboardKey"
        :data="data?.call_interactions"
        :hourRange="hourRange"
        @handleDownload="downloadInteractionVoice"
      />
      <dashboard-interaction-messages
        :key="dashboardKey"
        :data="data?.messaging_interactions"
        :hourRange="hourRange"
        @handleDownload="downloadInteractionMessages"
      />
      <!-- <a-row :gutter="12" :key="dashboardKey"> -->
      <!-- <a-col :span="12"> -->
      <dashboard-resume-voice
        :data="data?.telephone_summary"
        :hourRange="hourRange"
        @handleDownload="downloadResumeVoice"
      />
      <!-- </a-col> -->
      <!-- <a-col :span="12">
          <dashboard-resume-charges
            :data="data?.charges_summary"
            :hourRange="hourRange"
            @handleDownload="downloadResumeCharge"
          />
        </a-col> -->
      <!-- </a-row> -->
      <DashboardTicketsChartSummary
        :key="dashboardKey"
        ref="typificationSummary"
        :data="data"
        :hourRange="hourRange"
        @handleDownload="downloadTicketChartSummary"
      />
      <DashboardTicketsChartSummaryState
        :key="dashboardKey"
        ref="typificationSummaryState"
        :data="data"
        :hourRange="hourRange"
        @handleDownload="downloadTicketChartSummaryState"
      />

      <a-row type="flex" justify="space-between" :gutter="12">
        <a-col :span="12">
          <dashboard-schedule-chart
            ref="schedule"
            :filters="{
              entity,
              portfolio,
              startDate: date_start,
              endDate: date_end,
              queue,
            }"
            :users="users"
          />
        </a-col>

        <a-col :span="12">
          <dashboard-user-state-time-chart
            ref="userTime"
            :filters="{
              entity,
              portfolio,
              startDate: date_start,
              endDate: date_end,
              queue,
            }"
            :users="users"
          />
        </a-col>
      </a-row>
    </div>
  </custom-scrollbar>
</template>

<script>
import { defineComponent, inject, ref } from "vue";
import moment from "moment-timezone";
import dayjs from "dayjs";
import { debounce } from "lodash";

import { fetchTicketsChartSummary, fetchUsers, downloadExcel } from "@/app/dashboard/services/";

import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import DashboardInteractionVoice from "../charts/DashboardInteractionVoice.vue";
import DashboardInteractionMessages from "../charts/DashboardInteractionMessages.vue";
import DashboardTicketsChartSummary from "../charts/DashboardTicketsChartSummary.vue";
import DashboardTicketsChartSummaryState from "../charts/DashboardTicketsChartSummaryState.vue";
import DashboardScheduleChart from "../charts/DashboardScheduleChart.vue";
import DashboardUserStateTimeChart from "../charts/DashboardUserStateTimeChart.vue";
import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";
import RangePicker from "../pickers/RangePicker.vue";
import QueuePicker from "@/app/shared/components/pickers/QueuePicker.vue";

// import DashboardResumeCharges from "../charts/DashboardResumeCharges.vue";
import DashboardResumeVoice from "../charts/DashboardResumeVoice.vue";
import HubspotPermissionUpdateModal from "../modals/HubspotPermissionUpdateModal.vue";
export default defineComponent({
  components: {
    CustomScrollbar,
    EntityPicker,
    CampaignPicker,
    RangePicker,
    DashboardTicketsChartSummary,
    DashboardTicketsChartSummaryState,
    DashboardInteractionVoice,
    DashboardInteractionMessages,
    // DashboardResumeCharges,
    DashboardResumeVoice,
    DashboardScheduleChart,
    DashboardUserStateTimeChart,
    QueuePicker,
    HubspotPermissionUpdateModal,
  },
  setup() {
    const entity = ref("");
    const portfolio = ref(0);
    const queue = ref("");
    const date_start = ref("");
    const date_end = ref("");
    const today = ref(new Date());
    const showBanner = inject("showBanner");
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/dashboards/dashboards/`;

    return {
      entity,
      portfolio,
      date_start,
      date_end,
      today,
      showBanner,
      queue,
      DOCS_URL,
    };
  },
  data() {
    return {
      data: {},
      users: [],
      dashboardKey: 1,
      dataPortfolios: [],
    };
  },
  async mounted() {
    const myToday = new Date(
      this.today.getFullYear(),
      this.today.getMonth(),
      this.today.getDate(),
      0,
      0,
      0
    );
    const myTodayNight = new Date(
      this.today.getFullYear(),
      this.today.getMonth(),
      this.today.getDate(),
      23,
      59,
      59
    );
    this.date_start = moment(myToday).format("YYYY-MM-DD HH:mm:ss");
    this.date_end = moment(myTodayNight).format("YYYY-MM-DD HH:mm:ss");

    const response = await fetchUsers();
    this.fetchData();
    this.users = response?.results.filter((user) => user.fullname);
  },
  methods: {
    handleRefresh() {
      this.fetchData();
    },
    async fetchDashboard() {
      this.data = await fetchTicketsChartSummary({
        entity: this.entity,
        portfolio: this.portfolio,
        date_start: this.date_start,
        date_end: this.date_end,
        queue: this.queue,
      });
    },
    fetchData: debounce(async function () {
      if (!this.date_start) return;

      await Promise.all([
        this.fetchDashboard(),
        this.$refs.schedule?.fetchData?.(),
        this.$refs.userTime?.fetchData?.(),
      ]);

      this.dashboardKey++;
    }, 600),
    handleChange(payload) {
      this.date_start = payload.date_start;
      this.date_end = payload.date_end;
      this.fetchData();
    },
    async changeEntity(entity) {
      this.entity = entity;
      this.queue = "";
      this.portfolio = 0;
      this.fetchData();
    },
    changePortfolio(portfolio) {
      this.portfolio = portfolio || 0;
      this.fetchData();
    },
    handleChangeQueue(queue) {
      this.queue = queue;
      if (this.queue) this.fetchData();
    },
    setPortfolios(portfolios) {
      this.dataPortfolios = portfolios.map((portfolio) => portfolio.id);
    },
    async downloadInteractionVoice() {
      await downloadExcel(
        {
          entity: this.entity,
          portfolio: this.portfolio,
          date_start: this.date_start,
          date_end: this.date_end,
          queue: this.queue,
        },
        "resume-call-interactions"
      );
    },
    async downloadInteractionMessages() {
      await downloadExcel(
        {
          entity: this.entity,
          portfolio: this.portfolio,
          date_start: this.date_start,
          date_end: this.date_end,
          queue: this.queue,
        },
        "resume-messaging-interactions"
      );
    },
    async downloadResumeVoice() {
      await downloadExcel(
        {
          entity: this.entity,
          portfolio: this.portfolio,
          date_start: this.date_start,
          date_end: this.date_end,
          queue: this.queue,
        },
        "resume-calls"
      );
    },
    async downloadResumeCharge() {
      await downloadExcel(
        {
          entity: this.entity,
          portfolio: this.portfolio,
          date_start: this.date_start,
          date_end: this.date_end,
          queue: this.queue,
        },
        "resume-whatsapp"
      );
    },
    async downloadTicketChartSummary() {
      await downloadExcel(
        {
          entity: this.entity,
          portfolio: this.portfolio,
          date_start: this.date_start,
          date_end: this.date_end,
          queue: this.queue,
        },
        "resume-tickets"
      );
    },
    async downloadTicketChartSummaryState() {
      await downloadExcel(
        {
          entity: this.entity,
          portfolio: this.portfolio,
          date_start: this.date_start,
          date_end: this.date_end,
          queue: this.queue,
        },
        "resume-ticket-state"
      );
    },
  },
  computed: {
    hourRange() {
      const startDate = dayjs(this.date_start).format("YYYY-MM-DD");
      const endDate = dayjs(this.date_end).format("YYYY-MM-DD");

      const hourRange = {};

      if (startDate === endDate) {
        const startHour = dayjs(this.date_start).hour();
        const endHour = dayjs(this.date_end).hour();

        const hourDiff = endHour - startHour;

        for (let i = 0; i <= hourDiff; i++) {
          hourRange[startHour + i] = null;
        }
      }

      return hourRange;
    },
  },
});
</script>

<style lang="sass" scoped>
.section
  padding: 12px
  display: flex
  flex-direction: column
  gap: 12px

  &__top
    margin-top: 10px
    color: $gray-9
  &__button
    text-align: end
  &__filter
    width: 14em
    margin-bottom: 0px
    &-range
      margin-bottom: 0px
:deep(.apexcharts-toolbar)
  z-index: 1
</style>
